import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Client } from '@models/profile/model';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs';

import { ClientState, ClientStore } from './client.store';

@Injectable({
  providedIn: 'root',
})
export class ClientQuery extends QueryEntity<ClientState> {
  protected store: ClientStore;

  constructor() {
    const store = inject(ClientStore);

    super(store);

    this.store = store;
  }

  public getActiveId(): string {
    return super.getActiveId() as string;
  }

  public selectActiveWhenLoaded(): Observable<Client> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectActive())
    );
  }
}
